import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _createClass from "@babel/runtime/helpers/createClass";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _wrapNativeSuper from "@babel/runtime/helpers/wrapNativeSuper";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _regeneratorRuntime from "@babel/runtime/regenerator";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { getReferrer } from './env';
import { $window, $XMLHttpRequest } from './mini-adapter';
export var AJAXError = function (_Error) {
  _inherits(AJAXError, _Error);

  var _super = _createSuper(AJAXError);

  function AJAXError(status, statusText, url, body) {
    var _this;

    _classCallCheck(this, AJAXError);

    _this = _super.call(this, "AJAXError: ".concat(statusText, " (").concat(status, "): ").concat(url));

    _defineProperty(_assertThisInitialized(_this), "status", void 0);

    _defineProperty(_assertThisInitialized(_this), "statusText", void 0);

    _defineProperty(_assertThisInitialized(_this), "url", void 0);

    _defineProperty(_assertThisInitialized(_this), "body", void 0);

    _this.status = status;
    _this.statusText = statusText;
    _this.url = url;
    _this.body = body;
    return _this;
  }

  return _createClass(AJAXError);
}(_wrapNativeSuper(Error));

function makeFetchRequest(requestParameters, callback) {
  var request = new Request(requestParameters.url, {
    method: requestParameters.method || 'GET',
    body: requestParameters.body,
    credentials: requestParameters.credentials,
    headers: requestParameters.headers,
    referrer: getReferrer(),
    signal: requestParameters === null || requestParameters === void 0 ? void 0 : requestParameters.signal
  });

  if (requestParameters.type === 'json') {
    request.headers.set('Accept', 'application/json');
  }

  return fetch(request).then(function (response) {
    if (response.ok) {
      return (requestParameters.type === 'arrayBuffer' ? response.arrayBuffer() : requestParameters.type === 'json' ? response.json() : response.text()).then(function (result) {
        callback(null, result, response.headers.get('Cache-Control'), response.headers.get('Expires'));
      }).catch(function (err) {
        callback(new Error(err.message));
      });
    }

    return response.blob().then(function (body) {
      return callback(new AJAXError(response.status, response.statusText, requestParameters.url, body));
    });
  }).catch(function (error) {
    callback(new Error(error.message));
  });
}

function makeXMLHttpRequest(requestParameters, callback) {
  var xhr = new $XMLHttpRequest();
  xhr.open(requestParameters.method || 'GET', requestParameters.url, true);

  if (requestParameters.type === 'arrayBuffer') {
    xhr.responseType = 'arraybuffer';
  }

  for (var k in requestParameters.headers) {
    if (requestParameters.headers.hasOwnProperty(k)) {
      xhr.setRequestHeader(k, requestParameters.headers[k]);
    }
  }

  if (requestParameters.type === 'json') {
    xhr.responseType = 'text';
    xhr.setRequestHeader('Accept', 'application/json');
  }

  xhr.withCredentials = requestParameters.credentials === 'include';

  xhr.onerror = function () {
    callback(new Error(xhr.statusText));
  };

  xhr.onload = function () {
    if ((xhr.status >= 200 && xhr.status < 300 || xhr.status === 0) && xhr.response !== null) {
      var _data = xhr.response;

      if (requestParameters.type === 'json') {
        try {
          _data = JSON.parse(xhr.response);
        } catch (err) {
          return callback(err);
        }
      }

      callback(null, _data, xhr.getResponseHeader('Cache-Control'), xhr.getResponseHeader('Expires'));
    } else {
      var body = new Blob([xhr.response], {
        type: xhr.getResponseHeader('Content-Type')
      });
      callback(new AJAXError(xhr.status, xhr.statusText, requestParameters.url, body));
    }
  };

  xhr.send(requestParameters.body);
  return xhr;
}

function makeRequest(requestParameters, callback) {
  return makeXMLHttpRequest(requestParameters, callback);
}

export var getJSON = function getJSON(requestParameters, callback) {
  return makeRequest(_objectSpread(_objectSpread({}, requestParameters), {}, {
    type: 'json'
  }), callback);
};
export var getArrayBuffer = function getArrayBuffer(requestParameters, callback) {
  return makeRequest(_objectSpread(_objectSpread({}, requestParameters), {}, {
    type: 'arrayBuffer'
  }), callback);
};
export var postData = function postData(requestParameters, callback) {
  return makeRequest(_objectSpread(_objectSpread({}, requestParameters), {}, {
    method: 'POST'
  }), callback);
};

function sameOrigin(url) {
  var a = $window.document.createElement('a');
  a.href = url;
  return a.protocol === $window.document.location.protocol && a.host === $window.document.location.host;
}

var transparentPngUrl = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAAC0lEQVQYV2NgAAIAAAUAAarVyFEAAAAASUVORK5CYII=';

function arrayBufferToImage(data, callback) {
  var img = new $window.Image();
  var URL = $window.URL || $window.webkitURL;
  img.crossOrigin = 'anonymous';

  img.onload = function () {
    callback(null, img);
    URL.revokeObjectURL(img.src);
    img.onload = null;
    window.requestAnimationFrame(function () {
      img.src = transparentPngUrl;
    });
  };

  img.onerror = function () {
    return callback(new Error('Could not load image. Please make sure to use a supported image type such as PNG or JPEG. Note that SVGs are not supported.'));
  };

  var blob = new Blob([new Uint8Array(data)], {
    type: 'image/png'
  });
  img.src = data.byteLength ? URL.createObjectURL(blob) : transparentPngUrl;
}

function arrayBufferToImageBitmap(data, callback) {
  var blob = new Blob([new Uint8Array(data)], {
    type: 'image/png'
  });
  createImageBitmap(blob).then(function (imgBitmap) {
    callback(null, imgBitmap);
  }).catch(function (e) {
    callback(new Error("Could not load image because of ".concat(e.message, ". Please make sure to use a supported image type such as PNG or JPEG. Note that SVGs are not supported.")));
  });
}

export var getImage = function getImage(requestParameters, callback) {
  return getArrayBuffer(requestParameters, function (err, imgData) {
    if (err) {
      callback(err);
    } else if (imgData) {
      var imageBitmapSupported = typeof createImageBitmap === 'function';

      if (imageBitmapSupported) {
        arrayBufferToImageBitmap(imgData, callback);
      } else {
        arrayBufferToImage(imgData, callback);
      }
    }
  });
};

var arrayBufferToTiffImage = function () {
  var _ref = _asyncToGenerator(_regeneratorRuntime.mark(function _callee(data, callback, rasterParser) {
    var _yield$rasterParser, rasterData, width, height, defaultMIN, defaultMAX;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _context.next = 3;
            return rasterParser(data);

          case 3:
            _yield$rasterParser = _context.sent;
            rasterData = _yield$rasterParser.rasterData;
            width = _yield$rasterParser.width;
            height = _yield$rasterParser.height;
            defaultMIN = 0;
            defaultMAX = 8000;
            callback(null, {
              data: rasterData,
              width: width,
              height: height,
              min: defaultMIN,
              max: defaultMAX
            });
            _context.next = 15;
            break;

          case 12:
            _context.prev = 12;
            _context.t0 = _context["catch"](0);
            callback(null, new Error('' + _context.t0));

          case 15:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[0, 12]]);
  }));

  return function arrayBufferToTiffImage(_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}();

export var getTiffImage = function getTiffImage(requestParameters, callback, rasterParser) {
  return getArrayBuffer(requestParameters, function (err, imgData) {
    if (err) {
      callback(err);
    } else if (imgData) {
      arrayBufferToTiffImage(imgData, callback, rasterParser);
    }
  });
};
//# sourceMappingURL=ajax.js.map